/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import Axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import DashboardContext from "../../../Context";
import TableJobDispatchWorker from "./TableJobDispatchWorker";

const ModalJobDispatchWorker = ({
  showitem,
  handleCloseMoudal,
  id,
  persianStartWork,
  handeldeleteitem,
  handleRefreshGridWorker,
}) => {

  const { sideBardata, authentication, urldashboard } =
    useContext(DashboardContext);

  const [arryactions, setArryactions] = useState([]);

  const [loadingFrom, setLoadingFrom] = useState(false);

  const [reload, setReload] = useState(false);

  const [formData, setFormData] = useState({ orderScheduleId: id });

  useEffect(() => {

    if (sideBardata) {
      sideBardata.map((item) => {
        item.controllers.filter((find) => {
          if (`/${find.controller}` === "/JobDispatch") {
            setArryactions(find.actions);

            return find;
          }
        });
      });
    }
    return () => { };
  }, [reload]);

  // const handelValue = (name, value) => {
  //   switch (name) {
  //     case "workerId":
  //       setFormData({ ...formData, workerId: value });
  //       break;
  //     case "ignoreFormOrder":
  //       setFormData({ ...formData, ignoreFormOrder: value });
  //       break;
  //     case "isFavorite":
  //       setFormData({ ...formData, isFavorite: value });
  //       break;
  //     case "hasAdditionalService":
  //       setFormData({ ...formData, hasAdditionalService: value });
  //       break;
  //     default:
  //       break;
  //   }
  // };

  return (
    <Modal show={showitem} onHide={handleCloseMoudal} size={"lg"}>
      <Modal.Header>
        <Modal.Title>وضعیت پخش کار نیروها {persianStartWork}</Modal.Title>
        <i
          className="fa fa-times mr-auto"
          style={{ fontSize: "16px", cursor: "pointer" }}
          onClick={handleCloseMoudal}
          aria-hidden="true"
        ></i>
      </Modal.Header>

      <Modal.Body>

        <TableJobDispatchWorker
          urldata="/Order/JobDispatchWorkers"
          reload={() => setReload(!reload)}
          setLoadingOff={() => setReload(false)}
          isform
          itemname="orderScheduleId"
          params={id}
          page="1"
          pageSiz="20"
          arryactions={arryactions}
        />
      </Modal.Body>

      <Modal.Footer>


        <Button
          disabled={reload}
          onClick={() => setReload(!reload)}
          variant="success"
        >
          {reload ? (
            <i className="fa fa-spinner fa-pulse fa-fw"></i>
          ) : (
            "به روز رسانی"
          )}
        </Button>
      </Modal.Footer>

    </Modal>
  );
};

export default ModalJobDispatchWorker;
